<template>
  <v-data-table
    :headers="headers"
    :items="value.items"
    :options.sync="value.options"
    :hide-default-footer="value.serverItemsLength > 10 ? false : true"
    :server-items-length="value.serverItemsLength"
    :loading="value.loading"
    disable-sort
    class="elevation-0"
  >
    <template v-slot:item.timestamp="{ item }">
      {{ dateFormattingHours(item.timestamp) }}
    </template>

    <template v-slot:item.userName="{ item }">
      {{ item.userName ? item.userName : item.dealerName }}
    </template>

    <template v-slot:item.file="{ item }">
      <a
        v-if="item.file && item.file.url && item.file.uuid"
        :href="item.file ? item.file.url : ''"
        @click.prevent="fileDownload(item.file.uuid, $event)"
      >
        {{ item.file.name }}
      </a>
      <template v-else>
        {{ item.file ? item.file.name : '' }}
      </template>
    </template>

    <template v-slot:item.note="{ item }">
      <div class="d-flex align-start" v-if="item.note && item.publicNote === true">
        <div class="col pl-0">
          {{ reduceComment(item.note).comment }}
        </div>

        <v-dialog v-model="item.dialog" v-if="reduceComment(item.note).reduced" width="500">
          <template v-slot:activator="{ on }">
            <v-btn depressed v-on="on" height="40px" color="primary" small class="mt-2 ml-2">
              Zobrazit komentář
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              <v-row>
                <v-col cols="10">
                  Komentář
                </v-col>

                <v-col class="text-right">
                  <v-btn depressed icon @click="item.dialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-title>

            <v-card-text>
              {{ item.note }}
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { downloadFile } from '@/components/mixins/downloadFile';

export default {
  name: 'RequestActivities',
  mixins: [downloadFile],
  props: {
    value: {
      type: Object,
      required: true,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Datum',
          value: 'timestamp',
        },
        {
          text: 'Jméno',
          value: 'userName',
        },
        {
          text: 'Typ aktivity',
          value: 'type.localizedText',
        },
        {
          text: 'Příloha',
          value: 'file',
        },
        {
          text: 'Komentář',
          value: 'note',
        },
      ],
    };
  },
  methods: {
    showCommentDialog(item) {
      this.$emit('openCommentDialog', item);
    },
    reduceComment(comment) {
      if (comment && comment.length > 100) {
        return {
          comment: `${comment.substring(0, 100)} ...`,
          reduced: true,
        };
      }
      return {
        comment,
        reduced: false,
      };
    },
    fileDownload(uuid, event) {
      this.downloadFile(event, `requests/files/${uuid}`);
    },
  },
  watch: {
    'value.options': {
      handler(options) {
        this.$store.commit('settings/TABLE_ITEMS_UPDATE', {
          tableName: 'requestsActivities',
          itemsPerPage: options.itemsPerPage,
        });
        this.$emit('onChangeOptions');
      },
    },
  },
};
</script>
